import React from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  DialogActions
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export default function PolicyViewModal({ open, onClose, policyData = {} }) {
  const handleDownloadPDF = () => {
    if (policyData.url) {
      window.open(policyData.url, '_blank');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle variant="h6">View Policy</DialogTitle>
      <DialogContent dividers>
        <Paper sx={{ p: 3, borderRadius: 2 }} elevation={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Document Details
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                {[
                  { label: "Title", value: policyData.title },
                  { label: "Version Number", value: policyData.policyNumber },
                  { label: "Type", value: policyData.type },
                  { label: "Description", value: policyData.description },
                  { 
                    label: "Expiry", 
                    value: policyData.expiryValue > 0 
                      ? `${policyData.expiryValue} ${policyData.expiryType}`
                      : "No expiry"
                  },
                  { label: "Version", value: policyData.versionNumber || 1 },
                  { 
                    label: "Status", 
                    value: policyData.status 
                      ? policyData.status.charAt(0).toUpperCase() + policyData.status.slice(1)
                      : "N/A"
                  }
                ].map((field, index) => (
                  <Box 
                    key={field.label}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'start',
                      mb: 2,
                      "&:last-child": { mb: 0 }
                    }}
                  >
                    <Typography 
                      variant="subtitle2" 
                      color="primary" 
                      sx={{ 
                        minWidth: '120px',
                        pt: 0.5
                      }}
                    >
                      {field.label}:
                    </Typography>
                    <Typography variant="body1">
                      {field.value || "N/A"}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                mb: 2 
              }}>
                <Typography variant="h6">
                  Policy Document
                </Typography>
                {policyData.url && (
                  <IconButton 
                    color="primary" 
                    onClick={handleDownloadPDF}
                    title="Download PDF"
                  >
                    <DownloadIcon />
                  </IconButton>
                )}
              </Box>

              {policyData.url ? (
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 1,
                    overflow: "hidden",
                    height: "500px",
                  }}
                >
                  <iframe
                    src={policyData.url}
                    title="PDF Preview"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  ></iframe>
                </Box>
              ) : (
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 4,
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  <Typography>No document available</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
